import React, { useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import Loader from '@/modules/base/components/loader/loader'
import lang from '@/lang'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  loader: {
    height: '100%',
  },
}))

const PanelContent = React.forwardRef(function PanelContent(props, ref) {
  const {
    children,
    className = '',
    isLoading = false,
    usePerfectScrollbar = false,
    perfectScrollbarOptions = {},
  } = props

  const classes = useStyles()

  const Component = usePerfectScrollbar ? PerfectScrollbar : 'div'

  useEffect(() => {
    const contentRef = document.querySelector(`.${classes.root} > *:not(.${classes.loader})`)
    if (usePerfectScrollbar && contentRef && ref) {
      const resizeObserver = new ResizeObserver(() => {
        ref.current?.forceUpdate()
      })

      resizeObserver.observe(contentRef)

      return () => {
        resizeObserver.disconnect()
      }
    }
  }, [])

  const scrollbarProps = usePerfectScrollbar ? { options: perfectScrollbarOptions } : {}

  return (
    <Component ref={ref} className={clsx(classes.root, className)} {...scrollbarProps}>
      {isLoading && <Loader customClass={classes.loader} text={lang.gmi.loaderText} visible={isLoading} />}
      {children}
    </Component>
  )
})

PanelContent.propTypes = {
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  usePerfectScrollbar: PropTypes.bool,
  perfectScrollbarOptions: PropTypes.object,
}

export default PanelContent
